import { Check } from "lucide-react";
import { cn } from "../../lib/cn";

export interface Step {
	id: string;
	label: string;
	description: string;
	complete: boolean;
}

interface StepperProps {
	steps: readonly Step[];
	current: number;
	onSelect: (index: number) => void;
}

export const Stepper = ({ steps, current, onSelect }: StepperProps) => (
	<ol className="flex flex-col gap-1">
		{steps.map((step, index) => {
			const isCurrent = index === current;
			const isDone = step.complete;

			return (
				<li key={step.id}>
					<button
						type="button"
						onClick={() => onSelect(index)}
						className={cn(
							"flex w-full items-start gap-3 rounded-md px-3 py-2 text-left transition-colors",
							isCurrent ? "bg-raised" : "hover:bg-raised",
						)}
					>
						<span
							className={cn(
								"mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border text-xs",
								isDone
									? "border-ink bg-ink text-surface"
									: isCurrent
										? "border-ink text-ink"
										: "border-line-strong text-ink-faint",
							)}
						>
							{isDone ? <Check className="h-3 w-3" strokeWidth={3} /> : index + 1}
						</span>
						<span className="min-w-0">
							<span
								className={cn(
									"block text-sm",
									isCurrent ? "font-medium text-ink" : "text-ink-muted",
								)}
							>
								{step.label}
							</span>
							<span className="block text-xs text-ink-faint">{step.description}</span>
						</span>
					</button>
				</li>
			);
		})}
	</ol>
);
